import { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LangProvider } from "./lib/lang";
import { Toaster } from "sonner";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Classes from "./pages/Classes";
import Faqs from "./pages/Faqs";
import Contact from "./pages/Contact";

class ErrorBoundary extends Component {
  state = { err: false };
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#FDFBF7] p-10 text-center">
          <p className="font-display text-2xl text-[#1E1B4B]">Something went wrong.</p>
          <a href="/" className="rounded-full bg-[#1E1B4B] px-6 py-3 text-sm font-semibold text-[#FDFBF7]">
            Reload
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

function LenisInit() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <LenisInit />
        <ScrollToTop />
        <ErrorBoundary>
          <div className="flex min-h-screen flex-col">
            <Nav />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/classes" element={<Classes />} />
                <Route path="/faqs" element={<Faqs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="bottom-center" richColors />
          </div>
        </ErrorBoundary>
      </BrowserRouter>
    </LangProvider>
  );
}
